module.exports = __webpack_public_path__ + "static/media/finance smart (2).956a42e3.svg";